import { render } from "./MailSend.vue?vue&type=template&id=1490aa25"
import script from "./MailSend.vue?vue&type=script&lang=js"
export * from "./MailSend.vue?vue&type=script&lang=js"

import "./MailSend.vue?vue&type=style&index=0&id=1490aa25&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__